import React, { Component, useEffect } from 'react'
import { HashRouter, Route, Switch, useLocation } from 'react-router-dom'
import './scss/style.scss'
import { initGA, trackPageView } from './lib/analytics'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// ยิง page_view ไปที่ GA4 ทุกครั้งที่ route เปลี่ยน (ต้องอยู่ใต้ <HashRouter>
// เพื่อใช้ useLocation ได้ — no-op ถ้ายังไม่ได้ตั้งค่า REACT_APP_GA_MEASUREMENT_ID)
function AnalyticsRouteTracker() {
  const location = useLocation()

  useEffect(() => {
    initGA()
  }, [])

  useEffect(() => {
    trackPageView(location.pathname + location.hash)
  }, [location])

  return null
}

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const ForgotPassword = React.lazy(() => import('./views/pages/forgotpassword/ForgotPassword'))

class App extends Component {
  render() {
    return (
      <HashRouter>
        <AnalyticsRouteTracker />
        <React.Suspense fallback={loading}>
          <Switch>
            <Route exact path="/login" name="Login Page" render={(props) => <Login {...props} />} />
            <Route
              exact
              path="/forgotpassword"
              name="Forgot Password Page"
              render={(props) => <ForgotPassword {...props} />}
            />
            <Route path="/" name="Home" render={(props) => <DefaultLayout {...props} />} />
          </Switch>
        </React.Suspense>
      </HashRouter>
    )
  }
}

export default App
